import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  updateItem,
  removeItem,
  setGuestEmail,
  setGuestFirst,
} from "../redux/features/cartSlice";
import { setSelectedWave } from "../redux/features/cartSlice";
import Cookies from "js-cookie";
import { sendGTMEvent } from '@next/third-parties/google'
import { sendMetaConversionEvent } from "@services/paymentAPI";

export const useTicketHandler = (tickets, eventID) => {
  const [waveStates, setWaveStates] = useState({});
  const selectedWave = useSelector((state) => state.cart.selectedWave);
  const selectedItems = useSelector(
    (state) => state.cart.events[eventID] || []
  );
const user = JSON.parse(Cookies.get("user")??"{}");
  const dispatch = useDispatch();
  const initialQuantities = tickets.reduce((acc, ticket) => {
    ticket.sales.forEach((wave) => {
      acc[wave.waveID] = 0;
    });
    return acc;
  }, {});
  const [quantities, setQuantities] = useState(() => {
    selectedItems.forEach((item) => {
      initialQuantities[item.waveID] = item.quantity;
    });

    return initialQuantities;
  });
  // const [quantities, setQuantities] = useState(initialQuantities);
  const handleContinueAsGuest = (email, first, last) => {
    if (selectedWave) {
      const selectedItem = selectedItems.find(
        (item) => item.waveID === selectedWave
      );
      if (selectedItem) {
        dispatch(
          setGuestEmail({ eventID, waveID: selectedWave, email }),
          setGuestFirst({ eventID, waveID: selectedWave, first })
        );
      } else {
        console.error("No selected item found");
      }
    } else {
      console.error("No selected wave found");
    }
  };
  const handleTicketClick = (ticketID) => {
    setWaveStates({
      ...waveStates,
      [ticketID]: !waveStates[ticketID],
    });
  };

  // const handleIncrement = (wave, maxPerOrder, currency, ticketName) => {
  //   setQuantities((prevQuantities) => {
  //     const newQuantity = totalQuantity + 1;
  //     if (newQuantity <= maxPerOrder) {
  //       dispatch(
  //         updateItem({
  //           eventID,
  //           item: {
  //             waveID: wave.waveID,
  //             quantity: 1,
  //             price: wave.price,
  //             rawPrice: wave.rawPrice,
  //             waveName: wave.waveName,
  //             maxPerOrder: maxPerOrder,
  //             currency: currency,
  //             ticketName: ticketName,
  //           },
  //         })
  //       );
  //       return {
  //         ...prevQuantities,
  //         [wave.waveID]: newQuantity,
  //       };
  //     }
  //     return prevQuantities;
  //   });
  // };

  // const handleDecrement = (wave, maxPerOrder, currency, ticketName) => {
  //   setQuantities((prevQuantities) => {
  //     const newQuantity = totalQuantity - 1;
  //     if (newQuantity >= 0) {
  //       dispatch(
  //         updateItem({
  //           eventID,
  //           item: {
  //             waveID: wave.waveID,
  //             quantity: -1,
  //             price: wave.price,
  //             rawPrice: wave.rawPrice,
  //             waveName: wave.waveName,
  //             maxPerOrder: maxPerOrder,
  //             currency: currency,
  //             ticketName: ticketName,
  //           },
  //         })
  //       );
  //       return {
  //         ...prevQuantities,
  //         [wave.waveID]: newQuantity,
  //       };
  //     }
  //     return prevQuantities;
  //   });
  // };

// Within your component or module where handleIncrement is defined
  const selected = Cookies.get("testItems");

const getInitialSelectedItem = (selected) => {
  try {
    return selected ? JSON.parse(selected) : null;
  } catch (error) {
    console.error("Error parsing selected:", error);
    return null;
  }
};

const [selectedItem, setSelectedItem] = useState(
  getInitialSelectedItem(selected)
);

useEffect(() => {
  if (selected) {
    try {
      setSelectedItem(JSON.parse(selected));
    } catch (e) {
      console.error("Failed to parse selected:", e);
    }
  }
}, [selected]);
console.log("Selected Item:", selectedItem);
let totalQuantity = selectedItem?.quantity || 0;
const handleIncrement = (wave, maxPerOrder, currency, ticket, event, minPerOrder, incrementBy = 1) => {
  setQuantities((prevQuantities) => {
    let newQuantity;

    // Set the new quantity based on the previous quantity and increment value.
    if (prevQuantities[wave.waveID] === 0) {
      newQuantity = prevQuantities[wave.waveID] + minPerOrder;
    } else {
      newQuantity = prevQuantities[wave.waveID] + incrementBy;
    }

    // Ensure newQuantity does not exceed the maximum per order.
    if (newQuantity > maxPerOrder) {
      return prevQuantities;
    }

    // If a different wave is selected, remove the previous one.
    if (selectedWave && selectedWave !== wave.waveID) {
      dispatch(removeItem({ eventID, waveID: selectedWave }));
      prevQuantities[selectedWave] = 0;
    }

    // GTM Event for add-to-cart
     sendGTMEvent({event: "add_to_cart",
        user_data: {
          country: user?.country ?? "",
          customer_id: user?.id ?? "", // user id
          email: user?.email ?? "",
          first_name: user?.fname ?? "",
          last_name: user?.lastName ?? "",
          phone: user?.phoneNumber ?? "",
       },
    ecommerce: {
      currency: currency,
      value: wave.basePrice,
      items: [
      {
        item_id: ticket.ticketID, // ticketID // required
        item_name: ticket.name, // ticketName / /item_name
        price: wave.basePrice,
        quantity: newQuantity,
      }
      ]
    
      }})
    // Optionally, continue using the client-side FB Pixel if required.
    if (event.orgID === "Ea0wlLRXJ5SvZ1DMwlZx") {
      if (typeof fbq !== 'undefined') {
        fbq('track', 'AddToCart', {
          content_name: ticket.name,
          content_category: 'ticket',
          value: wave.customerPrice,
          currency: currency,
        });
      }
    }

    // Prepare custom data for Meta conversion event.
    const customData = {
      content_name: ticket.name,
      content_category: 'ticket',
      value: wave.customerPrice,
      currency: currency,
      waveID: wave.waveID,
      eventID: ticket.eventID,
    };

    // Trigger the server-to-server conversion event.
    // Note: Pass in any user data you wish to track. You might only send non-sensitive identifiers.
    sendMetaConversionEvent(event.orgID, 'AddToCart', { email: event.email }, customData)
      .catch((err) => console.error("Meta conversion tracking failed", err));

    // Prepare the item data to be saved in the local store/cookies.
    const testItems = {
      waveID: wave.waveID,
      quantity: newQuantity,
      basePrice: wave.basePrice,
      serviceFees: wave.serviceFees,
      customerPrice: wave.customerPrice,
      waveName: wave.waveName,
      maxPerOrder: maxPerOrder,
      currency: currency,
      ticketName: ticket.name,
      ticketID: ticket.ticketID,
      absorbFees: ticket.absorbFees,
      absorbPaymentFees: ticket.absorbPaymentFees,
      paymentOptions: ticket.ticketPaymentOptions ?? wave.paymentOptions,
      eventID: ticket.eventID,
      cashMapMain: wave.cashMapMain ?? {},
      cashMapAlt: wave.cashMapAlt ?? {},
      holderRequiredData: ticket.holderRequiredData,
      isFree: wave.isFree,
      continueAsGuest: event.continueAsGuest,
      minPerOrder: minPerOrder,
      incrementBy: ticket.incrementBy,
      orgID: event.orgID,
    };

    Cookies.set("testItems", JSON.stringify(testItems));
    dispatch(setSelectedWave(wave.waveID));
    dispatch(
      updateItem({
        eventID,
        item: {
          ...testItems,
        },
      })
    );

    // Return the updated quantities.
    return {
      ...prevQuantities,
      [wave.waveID]: newQuantity,
    };
  });
};

  

  const handleDecrement = (wave, maxPerOrder, currency, ticket, event, minPerOrder, incrementBy = 1) => {
    setQuantities((prevQuantities) => {
      let newQuantity;
  
      // Determine the new quantity based on the current quantity and incrementBy
      if (prevQuantities[wave.waveID] === minPerOrder) {
        newQuantity = 0; // If at the minimum, set to zero
      } else {
        newQuantity = prevQuantities[wave.waveID] - incrementBy;
        if (newQuantity < minPerOrder && newQuantity > 0) {
          newQuantity = minPerOrder; // Ensure it doesn't go below the minimum unless it reaches zero
        }
      }
  
      // Ensure the new quantity is valid (>= 0)
      if (newQuantity >= 0) {
        if (selectedWave && selectedWave !== wave.waveID) {
          dispatch(removeItem({ eventID, waveID: selectedWave }));
          prevQuantities[selectedWave] = 0;
        }
  
        dispatch(setSelectedWave(newQuantity > 0 ? wave.waveID : null)); // Update selected wave if quantity is > 0
  
        const testItems = {
          waveID: wave.waveID,
          quantity: newQuantity,
          basePrice: wave.basePrice,
          serviceFees: wave.serviceFees,
          customerPrice: wave.customerPrice,
          waveName: wave.waveName,
          maxPerOrder: maxPerOrder,
          currency: currency,
          ticketName: ticket.name,
          ticketID: ticket.ticketID,
          absorbFees: ticket.absorbFees,
          absorbPaymentFees: ticket.absorbPaymentFees,
          paymentOptions: ticket.ticketPaymentOptions,
          eventID: ticket.eventID,
          cashMapMain: wave.cashMapMain ?? {},
          cashMapAlt: wave.cashMapAlt ?? {},
          holderRequiredData: ticket.holderRequiredData,
          isFree: wave.isFree,
          continueAsGuest: event.continueAsGuest,
          minPerOrder: minPerOrder,
          incrementBy: ticket.incrementBy,
          orgID: event.orgID,
        };
        Cookies.set("testItems", JSON.stringify(testItems));
        dispatch(
          updateItem({
            eventID,
            item: {
              waveID: wave.waveID,
              quantity: newQuantity,
              basePrice: wave.basePrice,
              serviceFees: wave.serviceFees,
              customerPrice: wave.customerPrice,
              waveName: wave.waveName,
              maxPerOrder: maxPerOrder,
              currency: currency,
              ticketName: ticket.name,
              ticketID: ticket.ticketID,
              absorbFees: ticket.absorbFees,
              absorbPaymentFees: ticket.absorbPaymentFees,
              paymentOptions: ticket.ticketPaymentOptions,
              eventID: ticket.eventID,
              cashMapMain: wave.cashMapMain ?? {},
              cashMapAlt: wave.cashMapAlt ?? {},
              holderRequiredData: ticket.holderRequiredData,
              isFree: wave.isFree,
              continueAsGuest: event.continueAsGuest,
              minPerOrder: minPerOrder,
              incrementBy: ticket.incrementBy,
              orgID: event.orgID,
            },
          })
        );
  
        // Update the quantities state
        return {
          ...prevQuantities,
          [wave.waveID]: newQuantity,
        };
      }
  
      // If new quantity is invalid, return the previous state
      return prevQuantities;
    });
  };
  

  const handleAddToCart = (wave, maxPerOrder, currency, ticket) => {
    dispatch(
      addItem({
        eventID,
        item: {
          waveID: wave.waveID,
          quantity: 1,
          price: wave.price,
          rawPrice: wave.rawPrice,
          waveName: wave.waveName,
          maxPerOrder: maxPerOrder,
          currency: currency,
          basePrice: wave.basePrice,
          serviceFees: wave.serviceFees,
          customerPrice: wave.customerPrice,
          ticketName: ticket.name,
          ticketID: ticket.ticketID,
          absorbFees: ticket.absorbFees,
          absorbPaymentFees: ticket.absorbPaymentFees,
          paymentOptions: ticket.ticketPaymentOptions,
          eventID: ticket.eventID,
          cashMap: wave.cashMap ?? {},
          feesAmount: wave.feesAmount,
          paymentFeesAmount: wave.paymentFeesAmount,
          incrementBy: ticket.incrementBy
        },
      })
    );
  };

  return {
    waveStates,
    selectedItems,
    quantities,
    initialQuantities,
    handleTicketClick,
    handleIncrement,
    handleDecrement,
    handleAddToCart,
    handleContinueAsGuest,
  };
};
